import { BUILD_VERSION } from '../buildVersion';
import './BuildVersionBadge.scss';

type Props = {
  /** `header`：顶栏内联；`footer`：登录区下方 */
  variant?: 'header' | 'footer';
};

export default function BuildVersionBadge({ variant = 'footer' }: Props) {
  return (
    <span className={`build-version-badge build-version-badge--${variant}`} title="Build version">
      {BUILD_VERSION}
    </span>
  );
}
